<template> 
  <div class="superiority-box gx-5 p-4">
    <img :src="contentData.contentImage" alt="">
    <div class="only-title">{{ contentData.title }}</div>
  </div>
</template>

<script>

    export default {
        name: 'superiorityOnlyTitle',
        components: {},
        props:{
          'contentData':{
            type:Object,
            default: {},
          },
        },
        data() {
            return {
                
            }
        },
        methods:{

        }
    }
</script>